import React, { FC } from "react";
import IcoMoon from "react-icomoon";
import iconSet from "./selection.json";
import { IconProps } from "../../types";

const Icon: FC<IconProps> = ({
  name,
  className,
  fontSize = "1.43em",
  color,
}) => {
  return (
    <IcoMoon
      iconSet={iconSet}
      icon={name}
      size={fontSize}
      color={color}
      className={className}
    />
  );
};

export default Icon;
